import type { IntelligenceSyncerProgress } from "../../../api/intelligenceSyncer.service.js";
import styles from "./IntelligenceSyncer.module.css";

type ProgressStatsProps = {
  progress: IntelligenceSyncerProgress;
};

export function ProgressStats({ progress }: ProgressStatsProps) {
  const { processed, total, skipped, errors, estimatedRemaining } = progress;
  const percent = total > 0 ? Math.min(100, Math.round((processed / total) * 100)) : 0;

  return (
    <div className={styles.progressStats}>
      <div
        className={styles.progressBarTrack}
        role="progressbar"
        aria-valuenow={total > 0 ? percent : undefined}
        aria-valuemin={0}
        aria-valuemax={100}
        aria-label="Sync progress"
      >
        <div className={styles.progressBarFill} style={{ width: `${percent}%` }} />
      </div>
      <div className={styles.progressCaption}>
        {processed.toLocaleString()} / {total.toLocaleString()} processed ·{" "}
        {skipped.toLocaleString()} skipped · {errors.toLocaleString()} errors
        {estimatedRemaining && <> · {estimatedRemaining} remaining</>}
      </div>
    </div>
  );
}
